module.exports = __webpack_public_path__ + "static/img/error-outline-white.ef6077ad.svg";